module.exports = __webpack_public_path__ + "img/memo_logo.c98e15d9.png";